<!--@format-->
<template>
    <div v-cloak class="date-range-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Select Date Range</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="date-range">
                    <app-date-picker
                        v-model="startDateField"
                        class="date start"
                        label="Start Date"
                        placeholder="Start Date"
                        :is-valid="isCustomRangeValid"
                    />
                    <span v-if="!isCustomRangeValid" class="error-message-on-widget"
                        >The start date selected must come before the selected end date</span
                    >
                    <app-date-picker
                        v-model="endDateField"
                        class="date end"
                        label="End Date"
                        placeholder="End Date"
                        :is-valid="isCustomRangeValid"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <div class="action-container">
                    <app-button
                        class="export-button"
                        :disabled="
                            !isCustomRangeValid || startDateField == null || endDateField == null
                        "
                        :loading="exporting"
                        @click="exportReport()"
                    >
                        {{ exporting ? 'Exporting...' : 'Export' }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppDatePicker = () => import('@/components/common/app-date-picker');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppButton = () => import('@/components/common/app-button');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'date-range-widget',

    components: {
        'app-date-picker': AppDatePicker,
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
    },

    props: {
        options: {
            type: Object,
            default: null,
        },

        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            startDateField: null,
            endDateField: null,
            isCustomRangeValid: true,
            exporting: false,
        };
    },

    computed: {
        formattedStartDate() {
            return this.$moment(this.startDateField).startOf('day').utc().format('YYYY-MM-DDTHH:mm') + 'z';
        },

        formattedEndDate() {
            return this.$moment(this.endDateField).endOf('day').utc().format('YYYY-MM-DDTHH:mm') + 'z';
        },
    },

    watch: {
        startDateField() {
            this.checkInvalidDate();
        },

        endDateField() {
            this.checkInvalidDate();
        },
    },

    methods: {
        checkInvalidDate() {
            if (this.$moment(this.startDateField).isSame(this.$moment(this.endDateField))) {
                this.isCustomRangeValid = false;
            } else if (this.$moment(this.startDateField).isAfter(this.$moment(this.endDateField))) {
                this.isCustomRangeValid = false;
            } else {
                this.isCustomRangeValid = true;
            }
        },

        exportReport() {
            this.exporting = true;
            const { clientId, endpoint, type } = this.options;

            const queryParams = `?startDate=${this.formattedStartDate}&endDate=${this.formattedEndDate}&type=${type}`;

            this.$api
                .get(`/api/Clients/${clientId}/Reports/${endpoint}/Export${queryParams}`)
                .then((response) => {
                    window.open(response.data);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to export report.', { error });
                })
                .finally(() => {
                    this.exporting = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.date-range-widget .date-range .date.start.app-date-picker .vdp-datepicker__calendar {
    left: 0;
}

.date-range-widget .header {
    color: white;
}

.date-range-widget .date-range {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    position: relative;
}

.date-range-widget .app-date-picker {
    flex: 1;
}

.date-range-widget.widget .widget-footer {
    justify-content: flex-end;
}

.date-range-widget .date-range .error-message-on-widget {
    position: absolute;
    bottom: -30px;
    color: #f30070;
}
</style>
